module.exports = __webpack_public_path__ + "img/camera-active-icon.731ece93.svg";